import React from 'react';
import './PortfolioSingle.css';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaArrowRight, FaQuoteLeft, FaStar } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => {

  // Get portfolio details passed via router state
  const location = useLocation();
  const portfolio = location.state;

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={portfolio.title} page={portfolio.title} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* Portfolio Image Section */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* Portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* Portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* Portfolio Highlights Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Key Highlights:</h3>

              <p>Below is the Key Highlights for the session:</p>

              {/* List of Portfolio Highlights */}
              <ul>
                {portfolio.highlights.map((highlight, index) => {
                  return <li key={index}><FaStar className='icon' />{highlight}</li>
                })}
              </ul>

            </div>

            {/* Portfolio Agenda Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Event Agenda:</h3>

              <p>Below is the detailed agenda for the session:</p>

              {/* Portfolio Agenda List */}
              <ul>
                {portfolio.agenda.map((item, index) => {
                  return <li key={index}><FaArrowRight className='icon' />{item}</li>
                })}
              </ul>

            </div>

            {/* Attendee Testimonials Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Attendee Testimonials:</h3>

              {/* List of Testimonials */}
              <ul>
                {portfolio.testimonials.map((testimonial, index) => {
                  return <li key={index}> <div className='icon'><FaQuoteLeft /></div> <p><strong>"{testimonial.quote}"</strong> - {testimonial.author}</p></li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Portfolio details */}
        <PageSidebar
          heading={'Portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;